import { render, staticRenderFns } from "./BaseBoxSelect.vue?vue&type=template&id=24b86050&"
import script from "./BaseBoxSelect.vue?vue&type=script&lang=js&"
export * from "./BaseBoxSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseBoxSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports